<template>
  <div class="wrap">
    <el-row class="header">
      <span :span="1" class="go-back el-icon-back" @click="goBack">
      </span>
      <el-col :span="5">
        <span class="name">
          编辑草稿
        </span>
      </el-col>
    </el-row>
    <el-row class="infos">
      <el-col class="infos-wrap" v-for="(item,index) in infos" :key="index" :span="12">
        <el-col :span="4" class="title">{{item.name}}</el-col>
        <el-col :span="8">
          {{item.value}}
          <span v-if="item.name === 'ProductKey'" @click="copy(`${item.value}`)">
            复制
          </span>
        </el-col>
      </el-col>
    </el-row>
    <div class="btn-group">
        <div class="left">
          <!-- <el-button type="primary" @click="handlerClick('addBasic')">添加标准功能</el-button> -->
          <el-button  @click="handlerClick('addCustom')">添加自定义功能</el-button>
          <el-button  @click="handlerClick('into')">快速导入</el-button>
          <el-button  @click="handlerClick('PhysicalModel')">物模型TSL</el-button>
          </div>
        <div class="right">
          <span>历史版本：</span>
          <el-select v-model="modelVersion"  placeholder="请选择历史版本" @change="vesChange">
            <el-option
              v-for="item in versionOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
    </div>
    <div class="message">
      <i class="el-icon-info"></i>
      <p>您正在编辑的是草稿，需点击<span> 正式发布</span>后，物模型才会正式生效。</p>
    </div>
    <!-- table -->
    <div class="table">
      <el-table
        :data="tableData"
        :header-cell-style="{background:'#eef1f6',color:'#606266'}"
        style="width: 100%">
        <template slot="empty">
          <emptyView style="margin:10px">
          </emptyView>
        </template>
        <el-table-column
          prop="parentId"
          label="功能类型"
          align="center"
          >
        </el-table-column>
        <el-table-column
          prop="name"
          label="功能名称"
          align="center"
          >
        </el-table-column>
        <el-table-column
          prop="identifier"
          label="标识符"
          align="center"
          >
        </el-table-column>
        <el-table-column
          prop="types"
          label="数据类型/调用方式/事件类型"
          align="center"
          >
        </el-table-column>
        <el-table-column
          label="操作"
          align="center"
          >
           <template slot-scope="scope">
            <el-button
              size="mini"
              type="primary"
              @click="handlerEdit(scope.$index, scope.row)">编辑</el-button>
            <el-button
              size="mini"
              type="danger"
              @click="handlerDel(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="flexd">
      <el-button type="primary" @click="publish">
        发布上线
      </el-button>
      <el-button @click="goBack">
        返回
      </el-button>
    </div>
    <!-- 导入物模型 -->
    <modelDialog v-if="showImportModel.show" @close-view="showImportModel.show = false" @getImportPhyData="getImportPhyData" :showImportModel="showImportModel" :importPhydata="importPhydata"/>
    <!-- 物模型数据展示dialog -->
    <physicalModelDailog  @open="dialogVisible=false" :resData="resData" :dialogVisible="dialogVisible"/>
    <!-- 编辑dialog -->
    <viewMoreDailog v-if="infosDialogVisible" @open-view-dialog="infosDialogVisible=false" :proParams="proParams" :rowsdata="rowsData" :infosDialogVisible="infosDialogVisible"/>
    <!-- 添加自定义dialog -->
    <addCustomDailog v-if="addCustomDialogVisible" :proParams="proParams" @open-addcustom-dialog="addCustomDialogVisible=false" :addCustomDialogVisible="addCustomDialogVisible"/>
  </div>
</template>
<script>
import { copy } from '@/utils'
import { draftModel, unitsName, modelVersions, deleteModel, publishModel } from '@/api/productRegistration'
import emptyView from '@/components/empty_view/empty'
import modelDialog from '@/components/functionDefinitionDailogs/importModelDialog'
import physicalModelDailog from '@/components/functionDefinitionDailogs/PhysicalModelDailog'
import viewMoreDailog from '@/components/functionDefinitionDailogs/viewMoreDailog'
import addCustomDailog from '@/components/functionDefinitionDailogs/addCustomDailog'
export default {
  data () {
    return {
      sRow: null,
      infos: [
        {
          name: '产品名称',
          value: ''
        },
        {
          name: 'ProductKey',
          value: ''
        }
      ],
      versionOptions: [],
      modelVersion: '',
      tableData: [],
      resData: [], // 传给数据展示dialog的值
      rowsData: {}, // 传给编辑dialog的值
      showImportModel: { // modelDialog开关
        show: false
      },
      dialogVisible: false, // physicalModelDailog开关
      importPhydata: {
        beforeKey: '',
        date: Date.parse(new Date())
      },
      infosDialogVisible: false, // infosDialog开管
      addCustomDialogVisible: false, // addcustomdialog开关
      proParams: {}
    }
  },
  created () {
    this.sRow = JSON.parse(this.$route.query.sRow)
    this.infos[0].value = this.sRow.productName
    this.infos[1].value = this.sRow.productKey
    this.getDraftModelData()
    this.getUnitsName()
    this.getModelVersions()
    // this.getThingModelData()
  },
  components: {
    emptyView,
    modelDialog,
    physicalModelDailog,
    viewMoreDailog,
    addCustomDailog
  },
  mounted () {
  },
  methods: {
    getImportPhyData (val) {
      this.getDraftModelData(val)
    },
    /* getThingModelData (val) {
      console.log(val)
      this.tableData = []
      const params = {
        params: {
          productKey: val || this.sRow.productKey
        }
      }
      getThingModel(params).then(res => {
        this.resData = res.data.data.thingModel // 模型数据展示时需要profile'
        const physicalModelData = Object.assign({}, res.data.data.thingModel)
        delete physicalModelData.profile
        // console.log(Object.values(physicalModelData).reverse())
        for (let index = 0; index < Object.values(physicalModelData).length; index++) {
          Object.values(physicalModelData)[index].forEach((item) => {
            if (index === 0) {
              item.parentId = '服务'
            } else if (index === 1) {
              item.parentId = '属性'
            } else {
              item.parentId = '事件'
            }
          })
        }
        Object.values(physicalModelData).forEach((item) => {
          item.forEach((ele) => {
            if (ele.callType) ele.types = ele.callType
            if (ele.dataType) ele.types = ele.dataType.type
            if (ele.type) ele.types = ele.type
            // if (ele.accessMode) ele.accessMode = ele.accessMode === 'r' ? '只读' : '读写'
            this.tableData.push(ele)
          })
        })
        console.log(this.tableData)
      }).then(() => {
        this.getUnitsName()
      })
    }, */
    // 获取modelData
    getDraftModelData (val) {
      this.tableData = []
      const params = {
        params: {
          productKey: val || this.sRow.productKey,
          modelVersion: this.modelVersion ? this.modelVersion : ''
        }
      }
      draftModel(params).then(res => {
        this.modelVersion = res.data.data.modelVersion
        this.resData = res.data.data.thingModel // 模型数据展示时需要profile'
        const physicalModelData = Object.assign({}, res.data.data.thingModel)
        delete physicalModelData.profile
        // console.log(Object.values(physicalModelData).reverse())
        for (let index = 0; index < Object.values(physicalModelData).length; index++) {
          Object.values(physicalModelData)[index].forEach((item) => {
            if (index === 0) {
              item.parentId = '服务'
            } else if (index === 1) {
              item.parentId = '属性'
            } else {
              item.parentId = '事件'
            }
          })
        }
        Object.values(physicalModelData).forEach((item) => {
          item.forEach((ele) => {
            if (ele.callType) ele.types = ele.callType
            if (ele.dataType) ele.types = ele.dataType.type
            if (ele.type) ele.types = ele.type
            this.tableData.push(ele)
          })
        })
        console.log(this.tableData)
      })
    },
    // 获取单位名称
    getUnitsName () {
      const params = {
        params: {}
      }
      unitsName(params).then((res) => {
        res.data.data.forEach((item) => {
          this.uName = item.unitName + '/' + item.unit
          item.uName = this.uName
        })
        console.log(res.data.data)
        sessionStorage.setItem('selList', JSON.stringify(res.data.data))
      })
    },
    getModelVersions () {
      const params = {
        params: {
          productKey: this.sRow.productKey
        }
      }
      modelVersions(params).then(res => {
        res.data.data.map((res) => {
          const obj = {}
          obj.label = res
          obj.value = res
          this.versionOptions.push(obj)
        })
      })
    },
    vesChange (val) {
      this.modelVersion = val
      this.getDraftModelData()
    },
    goBack () {
      window.history.go(-1)
    },
    copy (val) {
      copy(val, () => {
        this.$message({
          type: 'success',
          message: '复制成功'
        })
      })
    },
    handlerClick (val) {
      switch (val) {
        case 'addBasic':
          console.log('addBasic')
          break
        case 'addCustom':
          this.proParams.prokey = this.sRow.productKey
          this.proParams.modelVersion = this.modelVersion
          this.addCustomDialogVisible = true
          console.log('addCustom')
          break
        case 'into':
          this.importPhydata.modelVersion = this.modelVersion
          this.importPhydata.date = Date.parse(new Date())
          this.importPhydata.beforeKey = this.sRow.productKey
          console.log('111', this.importPhydata)
          this.showImportModel.show = true
          break
        case 'PhysicalModel':
          this.dialogVisible = true
          break
      }
    },
    handlerEdit (index, row) {
      this.proParams.prokey = this.sRow.productKey
      this.proParams.modelVersion = this.modelVersion
      this.infosDialogVisible = true
      row.status = 'edit'
      row.index = index
      this.rowsData = row
      console.log(index, row)
    },
    handlerDel (row) {
      this.$confirm('确定删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        console.log(row)
        const params = {
          params: {
            productKey: this.sRow.productKey,
            modelVersion: this.modelVersion,
            identifier: row.identifier,
            abilityType: row.parentId === '服务' ? 2 : row.parentId === '事件' ? 3 : 1
          }
        }
        console.log('parans', params)
        deleteModel(params).then((res) => {
          if (res.data.code === 200) {
            this.getDraftModelData()
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    publish () {
      const params = {
        params: {
          productKey: this.sRow.productKey,
          modelVersion: this.modelVersion
        }
      }
      publishModel(params).then((res) => {
        if (res.data.code === 200) {
          window.history.go(-1)
        }
      })
    }
  }
}
</script>

<style lang='less' scoped>
  .wrap{
    padding: 0 24px 24px;
  }
  .header{
    display: flex;
    align-items: center;
    margin-bottom: 24px;
    .go-back{
      cursor: pointer;
    }
    .el-icon-back{
      font-size: 20px;
      font-weight: bold;
      width: 25px;
    }
    .name{
      margin-left: 20px;
      font-size: 28px;
      font-weight: 900;
    }
  }
  .infos{
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    font-size: 12px;
    margin-bottom: 16px;
    .infos-wrap{
      margin-bottom: 8px;
      span{
        margin-left: 20px;
        cursor: pointer;
        color: rgb(0, 112, 204);
      }
      .title{
        color: #888888;
      }
    }
  }
  .btn-group{
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
    .right{
      margin-left: 10px;
    }
  }
  .message{
    margin-bottom: 12px;
    padding: 12px 12px 12px 16px;
    display: flex;
    background-color: #e5f3ff;
    align-items: center;
    letter-spacing: 1px;
    i{
      color: skyblue;
      margin-right: 4px;
    }
    p{
      font-size: 12px;
      span{
        color: #0070cc;;
      }
    }
  }
  .table{
    margin-bottom: 20px;
  }
  .el-button--default{
    background-color: #fafafa;
  }
  .el-button--default, .el-button--danger,.el-button--primary{
    border-radius: 0;
    padding: 0 16px;
    line-height: 30px;
    font-size: 12px;
    border-width: 1px;
  }
</style>
